import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
import TransferPerformanceList from '../../components/TransferPerformanceList';
class TransferPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Transfer',
      },
      {
        breadcrumbName: 'Performance',
      },
    ];

    const transferListColumns = [
      {
        Header: 'Dispatch ID',
        accessor: 'dh_id',
      },
      {
        Header: 'Courier',
        accessor: 'driver',
      },
      {
        Header: 'Status',
        accessor: 'status',
        sortable: false,
      },
      {
        Header: 'Date',
        accessor: 'dispatch_date',
      },
    ];

    const customFilter = {
      id: 'type',
      value: 'transfer',
    };

    return (
      <div className="TransferPerformance">
        <PageHeader title="Transfer Performance " routes={breadCrumbs} />
        <Spacer />
        <Container>
          <TransferPerformanceList
            hasExport
            transferListColumns={transferListColumns}
            customFilter={customFilter}
            fetchText="Fetching Transfer List. . ."
            urlEndpoint="/transfer"
            typeDispatch="transfer"
          />
        </Container>
      </div>
    );
  }
}

export default TransferPerformance;
